import styled from 'styled-components';

export const StyledBackofficeFooter = styled.footer`
	font-size: 14px;
    font-family: 'Poppins', sans-serif;
    border-top: 1px solid #C5C6D0;
    padding: 20px 32px;
    position: relative;
    box-sizing: border-box;
    background-color: #fff;
    color: #8B8C99;
    
    p {
    	margin: 0;
    }
`;
